import React from "react";

const ITEMS = [
  "MBBCh",
  "MSc Highest Honours",
  "MRCS England",
  "Consultant Grade A Egypt",
];

export function CredentialsBar() {
  return (
    <div className="border-y border-accent bg-primary py-5 text-white">
      <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-center gap-x-6 gap-y-2 px-6 font-body text-sm font-light tracking-wide md:text-base">
        {ITEMS.map((item, i) => (
          <React.Fragment key={item}>
            {i > 0 && (
              <span className="hidden text-accent sm:inline" aria-hidden>
                •
              </span>
            )}
            <span>{item}</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
